export default function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-shape/src/pointRadial.js
// module id = 180
// module chunks = 0